import { connect } from 'react-redux';
import Component from './component';
import setDocumentsRoute from '../../actions/documents/documentsroute';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  handleSetDocumentsRedirectRoute: async () => {
    await dispatch(await setDocumentsRoute());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
